import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const { firstName, lastName, email, phone, message } = formData;
    const fullName = `${firstName} ${lastName}`;
    
    // Construct the WhatsApp message
    const whatsappMessage = `*New Inquiry from Website*\n\n*Name:* ${fullName}\n*Email:* ${email}\n*Phone:* ${phone}\n*Message:* ${message}`;
    
    // Encode the message for URL
    const encodedMessage = encodeURIComponent(whatsappMessage);
    
    // WhatsApp API URL
    const whatsappUrl = `https://wa.me/919844179579?text=${encodedMessage}`;
    
    // Open WhatsApp in a new tab
    window.open(whatsappUrl, '_blank');
    
    // Optional: Reset form or show success message after redirect
    setFormData({
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      message: ''
    });
  };

  // Google Maps embed URL for Pragati Vidyalaya New Campus
  // Coordinates: 14.2906475, 76.6595144
  // Place ID: 0x3bb0bdd3f0a71483:0x31e75d07a31d87f8
  const mapUrl = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3850.1689375000003!2d76.6595144!3d14.2906475!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bb0bdd3f0a71483%3A0x31e75d07a31d87f8!2sPragati%20Vidyalaya%20New%20Campus!5e0!3m2!1sen!2sus!4v1698000000000!5m2!1sen!2sus";

  return (
    <main className="contact-page">
      <div className="contact-container">
        <div className="contact-wrapper">
          {/* Left Section - Google Maps */}
          <div className="contact-map-section">
            <iframe
              src={mapUrl}
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Pragati Vidyalaya Location"
              className="google-map"
            ></iframe>
          </div>

          {/* Right Section - Contact Form */}
          <div className="contact-form-section">
            <h2 className="form-title">CONTACT US BY SUBMITTING THE FORM BELOW:</h2>
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="firstName">First Name *</label>
                <input
                  type="text"
                  id="firstName"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  required
                  placeholder="First Name"
                />
              </div>

              <div className="form-group">
                <label htmlFor="lastName">Last Name *</label>
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  required
                  placeholder="Last Name"
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="Email"
                />
              </div>

              <div className="form-group">
                <label htmlFor="phone">Phone Number *</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  placeholder="Phone Number"
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">Message *</label>
                <textarea
                  id="message"
                  name="message"
                  rows="6"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  placeholder="Message"
                ></textarea>
              </div>

              <button type="submit" className="submit-btn">
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Contact;

